import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'

interface UsePaginationProps {
  itemsPerPage?: number
  initialPage?: number
  tableKey?: string
}

interface UsePaginationResult {
  currentPage: number
  setCurrentPage: (currentPage: number) => void
  nextPage: () => void
  prevPage: () => void
  rowsPerPage: number
  setRowsPerPage: (page: number) => void
}

export const usePagination = ({
  itemsPerPage = 25,
  initialPage = 0,
  tableKey,
}: UsePaginationProps): UsePaginationResult => {
  const currentCompany = useSelector(
    (state: RootState) => state?.user?.currentCompany
  )

  const paginationState = useSelector(
    (state: any) => state.table?.[`${tableKey}_${currentCompany?.id}`]
  )

  const [currentPage, setCurrentPage] = useState<number>(
    tableKey ? paginationState?.page || initialPage : initialPage
  )
  const [rowsPerPage, setRowsPerPage] = useState<number>(
    tableKey ? paginationState?.rowsPerPage || itemsPerPage : itemsPerPage
  )

  useEffect(() => {
    if (paginationState?.page !== currentPage) {
      setCurrentPage(currentPage)
    }
  }, [paginationState?.page])

  useEffect(() => {
    if (paginationState?.rowsPerPage !== rowsPerPage) {
      setRowsPerPage(rowsPerPage)
    }
  }, [paginationState?.rowsPerPage])

  const nextPage = () => {
    setCurrentPage((prev) => prev + 1)
  }

  const prevPage = () => {
    setCurrentPage((prev) => prev - 1)
  }

  return {
    currentPage,
    setCurrentPage,
    nextPage,
    prevPage,
    rowsPerPage,
    setRowsPerPage,
  }
}
